<template>
  <div id="app">

    <div v-if="showLogin">
        <login v-model="showLogin" />
    </div>

    <div v-else>
        <home />
    </div>

    <footer>
      <el-row class="footer" type="flex" justify="center">
        <el-col align="center">
          <strong>Tower Management System</strong>&nbsp;<img class="footer-logo" src="static/favicon.png" />&nbsp;
          &copy; <a href="https://xolas.io" target="_blank">Xolas Sdn Bhd</a> {{year}}<br />
          Version {{this.version}}&nbsp;<span class="text-muted hidden-sm-and-down">|&nbsp;Desktop mininum resolution 1024 x 960.</span><br />
          <small>All data on this site belongs to <strong>{{this.xolasClient().name}}</strong>. It can only be used in accordance with their policies.</small><br />
        </el-col>
      </el-row>
    </footer>
  </div>

</template>

<script>
import Vue from 'vue'

import {appNow} from '@/lib/appTime'
import VueMq from 'vue-mq'

// import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'

import Element from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import { PopupManager } from 'element-ui/lib/utils/popup'

import XolasAtoms from '@/components/atoms'

Vue.use(Element, { locale: enLocale })
Vue.use(XolasAtoms)

// XOL-209: LayerHost's cascade drawers sit at z-index 3010..3050 (depth-tiered).
// Element UI's PopupManager defaults its allocator to 2000 — any dialog /
// drawer / message-box opened from INSIDE a LayerHost would render BEHIND
// it. Bump the base so PopupManager allocates above the LayerHost ceiling.
PopupManager.zIndex = 4000

Vue.use(VueMq, {
  breakpoints: {
    xs: 320,
    sm: 480,
    md: 768,
    lg: 1024,
    hg: Infinity
  }
})

import {VERSION} from '@/components/Data'

import Home from '@/components/Home'
import Login from '@/components/login/Login'

import VueChartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.use(VueChartkick, {adapter: Chart})

export default {
  name: 'app',


  components: {
    Home,
    Login
  },

  computed: {
    showLogin: function () {
      return !this.loggedIn()
    }
  },

  methods: {
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },

    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    }
  },

  data () {
    return {
      windowWidth: 0,
      windowHeight: 0,
      initState: true,
      year: appNow().format('YYYY'),
      version: VERSION + ' [' + this.getStore().env + ']',
      locData: []
    }
  },

  created () {
    this.initState = this.init()
  },

  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      // Init
      this.getWindowWidth()
      this.getWindowHeight()
    })
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Raleway', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}

.footer-logo {
  height: 2.85vh;
  width: auto;
}

.footer {
  top: 0;
  left: 0;
  width: 100%;
  color: snow;
  padding: 7.41px;
  padding-bottom: 1.5em;
  background-color: #2f3e57;
}
/*
.footer {
    width:100%;
    height:80px;
    position:absolute;
    bottom:0;
    left:0;
    color: snow;
    background-color: #2f3e57;
}
*/
@import './assets/css/normalize.css' ;
@import '~element-ui/lib/theme-chalk/index.css' ;
@import './assets/css/app.css' ;
@import './assets/fontawesome-6.1.2/css/all.css' ;

</style>
